import React from "react";
import "./App.scss";
import Config from "config/Config";

function App() {
  return (
    <div className="App">
      <Config />
    </div>
  );
}

export default App;
